<template>
	<section>
		<Header></Header>
		<div class="content-top">
            <img src="../../../static/images/corporate_culture_bg.png" alt="">
            <div class="top-bg-title">
                <p>企业文化</p>
                <p>ENTERPRISE CULTURE</p>
            </div>
        </div>
        <div class="content">
            <p>CERTIFICATE</p>
            <p>企业文化</p>
            <p class="doc">我们是一群满怀激情、勇于开拓的梦想家。我们勇于尝试未知，敢于突破常规，不断挑战技术的极限。每一位用户，都是我们珍视如友的宝贵伙伴。我们深知，深入理解用户的每一个细微需求，是设计出贴心、实用产品的基石。因此，我们时刻倾听用户的声音，不断优化产品，确保它能完美融入用户的数字生活。</p>
            <br/>
            <p>
                <img src="../../../static/images/corporate_culture_2.jpg" alt="">
            </p>
            <br/>
            <p class="doc">同时，我们秉持开放合作的精神，积极拥抱行业内外的创新力量，携手共创未来。我们相信，通过资源共享、优势互补，能够推动整个数字生态的繁荣发展，为用户带来更加丰富多元、便捷高效的数字生活体验。</p>
            <p class="doc">在未来，我们将继续作为探索者和引领者，不仅追求技术的卓越，更致力于将这份卓越转化为用户触手可及的美好，让每一个使用我们产品的瞬间，都成为用户数字生活中的亮点。</p>
            <br/>
            <p>
                <img src="../../../static/images/corporate_culture_1.png" alt="">
            </p>
            <br/>
        </div>
        <div class="content">
            <p>TEAM</p>
            <p>团队</p>
            <div class="image">
                <img src="../../../static/images/corporate_culture_6.png" alt="">
            </div>
        </div>
		<Footer></Footer>
	</section>
</template>

<script>
import Header from '../modules/Header';
import Footer from '../modules/Footer';
export default {
	name: 'CorporateCulture',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			//
		}
	},
    methods: {
        
    },
	computed: {}
}
</script>

<style scoped>
.content-top {
    position: relative;
    width: 100%;
    height: 1.5rem;
}
img {
    width: 100%;
    height: 100%;
}
.top-bg-title {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 1);
}
.top-bg-title p:nth-child(1) {
    font-size: 0.25rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}
.top-bg-title p:nth-child(2) {
    /* font-size: 0.25rem; */
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}
.content {
    width: 90%;
    margin: 0.3rem auto 0;
}
.content p:nth-child(1) {
    font-weight: 400;
    color: rgba(255, 113, 113, 1);
}
.content p:nth-child(2) {
    font-size: 0.18rem;
    font-weight: 400;
    margin: 0.06rem 0;
}
.content .doc{
    /* font-size: 20px; */
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 0.25rem;
    color: rgba(69, 69, 69, 1);
    text-align: justify;
    vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/components/views/corporateCulture.vue